// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Tabs_Tabs__imWQ7","List":"Tabs_List__2MSVk","Tab":"Tabs_Tab__drajW","Indicator":"Tabs_Indicator__V1HDB","Panel":"Tabs_Panel__ypgvH"};